import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class ParkWhizOAuthNotSetupError extends CodedError {
  static get errorName() {
    return errorCodes.parkWhizOAuthNotSetupError.code;
  }

  constructor(message: string = errorCodes.parkWhizOAuthNotSetupError.message) {
    super(message);
    this.code = errorCodes.parkWhizOAuthNotSetupError.code;
    this.message = `${message} ${errorCodes.parkWhizOAuthNotSetupError.code}`;
    this.name = errorCodes.parkWhizOAuthNotSetupError.name;
  }
}
